"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAddress = addAddress;
exports.cancelAutoRenew = cancelAutoRenew;
exports.changeUserPassword = changeUserPassword;
exports.deleteUserAddress = deleteUserAddress;
exports.fetchUser = fetchUser;
exports.getEligibleForRefund = getEligibleForRefund;
exports.getMembershipInformation = getMembershipInformation;
exports.getUserContactPreferences = getUserContactPreferences;
exports.getUserContactPreferencesByEmail = getUserContactPreferencesByEmail;
exports.reFetchUser = reFetchUser;
exports.resetChangeUserPassword = resetChangeUserPassword;
exports.resetSaveUserContactPreferencesByEmail = resetSaveUserContactPreferencesByEmail;
exports.saveUserContactPreferences = saveUserContactPreferences;
exports.saveUserContactPreferencesByEmail = saveUserContactPreferencesByEmail;
exports.setPrimaryAddress = setPrimaryAddress;
exports.submitPrivacyRequest = submitPrivacyRequest;
exports.unsubscribeFromUserContactPreferenceByEmail = unsubscribeFromUserContactPreferenceByEmail;
exports.updateUser = updateUser;
exports.verifyPrivacyRequest = verifyPrivacyRequest;
var _memberMgmtGatewayActionKeys = _interopRequireDefault(require("../constants/memberMgmtGatewayActionKeys"));
var _memberMgmtGatewayService = _interopRequireDefault(require("../services/memberMgmtGatewayService"));
function fetchUser(userId) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].FETCH_USER,
    payload: {
      promise: _memberMgmtGatewayService["default"].fetchUser(userId)
    }
  };
}
function reFetchUser(userId) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].REFETCH_USER,
    payload: {
      promise: _memberMgmtGatewayService["default"].fetchUser(userId)
    }
  };
}
function updateUser(params) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].UPDATE_USER,
    payload: {
      data: {
        params: params
      },
      promise: _memberMgmtGatewayService["default"].updateUser(params)
    }
  };
}
function addAddress(params) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].ADD_ADDRESS,
    payload: {
      data: {
        params: params
      },
      promise: _memberMgmtGatewayService["default"].updateUser(params)
    }
  };
}
function deleteUserAddress(userAddressId, addressId) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].DELETE_USER_ADDRESS,
    payload: {
      data: {
        userAddressId: userAddressId,
        addressId: addressId
      },
      promise: _memberMgmtGatewayService["default"].deleteUserAddress(userAddressId)
    }
  };
}
function setPrimaryAddress(userAddressId, addressId) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].SET_PRIMARY_ADDRESS,
    payload: {
      data: {
        userAddressId: userAddressId,
        addressId: addressId
      },
      promise: _memberMgmtGatewayService["default"].setPrimaryAddress(userAddressId)
    }
  };
}
function changeUserPassword(oldPassword, newPassword) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].CHANGE_PASSWORD,
    payload: {
      data: {
        oldPassword: oldPassword,
        newPassword: newPassword
      },
      promise: _memberMgmtGatewayService["default"].changePassword(oldPassword, newPassword)
    }
  };
}
function resetChangeUserPassword() {
  return {
    type: _memberMgmtGatewayActionKeys["default"].CHANGE_PASSWORD_RESET,
    payload: {}
  };
}
function getUserContactPreferences(userId) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].GET_USER_CONTACT_PREFERENCES,
    payload: {
      promise: _memberMgmtGatewayService["default"].getUserContactPreferences(userId)
    }
  };
}
function saveUserContactPreferences(params) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES,
    payload: {
      data: {
        params: params
      },
      promise: _memberMgmtGatewayService["default"].saveUserContactPreferences(params)
    }
  };
}
function getMembershipInformation(userId) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].GET_MEMBERSHIP_INFORMATION,
    payload: {
      data: {
        userId: userId
      },
      promise: _memberMgmtGatewayService["default"].getMembershipInformation(userId)
    }
  };
}
function getEligibleForRefund() {
  return {
    type: _memberMgmtGatewayActionKeys["default"].GET_ELIGIBLE_FOR_REFUND,
    payload: {
      promise: _memberMgmtGatewayService["default"].getEligibleForRefund()
    }
  };
}
function cancelAutoRenew() {
  return {
    type: _memberMgmtGatewayActionKeys["default"].CANCEL_AUTO_RENEW,
    payload: {
      promise: _memberMgmtGatewayService["default"].cancelAutoRenew()
    }
  };
}
function getUserContactPreferencesByEmail(email, apiToken) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].GET_USER_CONTACT_PREFERENCES_BY_EMAIL,
    payload: {
      promise: _memberMgmtGatewayService["default"].getUserContactPreferencesByEmail(email, apiToken)
    }
  };
}

// Unsubscribe action uses the same API as saving user contact preferences.
// It is a separate action to allow UI to render different alert messages on unsubscribing on page load vs. saving from a form submit.
function unsubscribeFromUserContactPreferenceByEmail(_ref) {
  var email = _ref.email,
    apiToken = _ref.apiToken,
    preferences = _ref.preferences;
  return {
    type: _memberMgmtGatewayActionKeys["default"].UNSUBSCRIBE_FROM_USER_CONTACT_PREFERENCE_BY_EMAIL,
    payload: {
      data: {
        params: {
          email: email,
          apiToken: apiToken,
          preferences: preferences
        }
      },
      promise: _memberMgmtGatewayService["default"].saveUserContactPreferencesByEmail({
        email: email,
        apiToken: apiToken,
        preferences: preferences
      })
    }
  };
}
function saveUserContactPreferencesByEmail(_ref2) {
  var email = _ref2.email,
    apiToken = _ref2.apiToken,
    preferences = _ref2.preferences;
  return {
    type: _memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES_BY_EMAIL,
    payload: {
      data: {
        params: {
          email: email,
          apiToken: apiToken,
          preferences: preferences
        }
      },
      promise: _memberMgmtGatewayService["default"].saveUserContactPreferencesByEmail({
        email: email,
        apiToken: apiToken,
        preferences: preferences
      })
    }
  };
}
function resetSaveUserContactPreferencesByEmail() {
  return {
    type: _memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES_BY_EMAIL_RESET
  };
}
function submitPrivacyRequest(_ref3) {
  var email = _ref3.email,
    privacyRequestType = _ref3.privacyRequestType;
  return {
    type: _memberMgmtGatewayActionKeys["default"].SUBMIT_PRIVACY_REQUEST,
    payload: {
      data: {
        params: {
          email: email,
          privacyRequestType: privacyRequestType
        }
      },
      promise: _memberMgmtGatewayService["default"].submitPrivacyRequest({
        email: email,
        privacyRequestType: privacyRequestType
      })
    }
  };
}
function verifyPrivacyRequest(_ref4) {
  var email = _ref4.email,
    verificationToken = _ref4.verificationToken,
    requestStatus = _ref4.requestStatus;
  return {
    type: _memberMgmtGatewayActionKeys["default"].VERIFY_PRIVACY_REQUEST,
    payload: {
      promise: _memberMgmtGatewayService["default"].verifyPrivacyRequest({
        email: email,
        verificationToken: verificationToken,
        requestStatus: requestStatus
      })
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/actions/memberMgmtGatewayActions.js
// module id = 578
// module chunks = 9